const FAVORITE_TABS = [
  { key: "Matches", label: "Matches" },
  { key: "Teams", label: "Teams" },
  { key: "Leagues", label: "Leagues" },
  { key: "Players", label: "Players" }
];
export {
  FAVORITE_TABS
};
